import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { DRCTEvent } from '@drct-web-apps/ui-types';
import { UiServiceEnvironment, UiServicesRegsitration, UiServicesUtils } from '@drct-web-apps/ui-services';
import { DatePipe } from '@angular/common';



@Component({
  selector: 'ui-web-event-card',
  templateUrl: './ui-web-event-card.component.html',
  providers: [ DatePipe ]
})
export class UiWebEventCardComponent implements OnInit {
  @Input({required: true}) event: DRCTEvent | null = null;
  @Input({required: true}) hideRegisterArea = false;

  public showRegisterButton = false;
  public showComingSoon     = false;

  private readonly datepipe: DatePipe = new DatePipe('en-US');

  constructor(private readonly router: Router, private readonly register: UiServicesRegsitration,
              private readonly utils: UiServicesUtils, private readonly env: UiServiceEnvironment) { }
  
  ngOnInit(): void {
    this.showRegisterButton = this.event?.events_register_active || false;
    this.showComingSoon     = this.event?.events_comming_soon || false;
  }

  public transformTime(time: string | undefined): string {
    return this.utils.transformTime(time);
  }

  public transformRegStartDate(): string {
    const startDate = this.event?.events_info?.events_register?.reg_start_date;
    const startTime = this.event?.events_info?.events_register?.reg_start_time;

    const formattedDate = this.datepipe.transform((startDate + " " + startTime), 'MMM dd, YYYY hh:mm a');
    return formattedDate ?? '';
  }

  public transformEventStartEndDates(startDate: string | undefined, endDate: string | undefined): string {
    let formattedDate = '';

    formattedDate = this.datepipe.transform(startDate, 'MMM d, y') ?? '';
    if(endDate !== startDate)
      formattedDate += ' - ' + (this.datepipe.transform(endDate, 'MMM d, y') ?? '');
    
    return formattedDate;
  }

  public onClickRegister(): void {
    this.register.destroy();

    this.register.event = this.event;
    this.router.navigate(['home', 'register']);  
  }

  public getEventImage(): string {
    return 'assets/uploads/img/' + this.event?.events_info?.events_banner;
  }

  public getEventFlyer(): string {
    return 'assets/uploads/img/' + this.event?.events_info?.events_flyer;
  }
}
